import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';

class CalendarState {
  store = new DomainStore();

  agent;

  startDate = new Date().toISOString();
  endDate = new Date().toISOString();

  events = [];
  isLoading = false;
  selectedEvent = {};

  errors = {};
  editingCustomEvent = {};

  constructor() {
    makeAutoObservable(this, {
      agent: false,
      store: false
    });
  }

  setInteractiveAgent(agent) {
    this.agent = agent;
  }

  async updateDates(startDate, endDate) {
    this.startDate = startDate;
    this.endDate = endDate;
  }

  get newCustomEventDefaults() {
    return {allDay: false};
  }

  async saveCustomEvent() {
    const {model, errors} = this.editingCustomEvent.isNew ?
      await this.store.post(
        endpoints.CUSTOM_CALENDAR_EVENTS.ALL,
        types.CUSTOM_CALENDAR_EVENT,
        this.editingCustomEvent
      ) :
      await this.store.patch(this.editingCustomEvent);

    this.errors = errors;

    if (!model) return;

    await this.agent.refresh();
    this.closeEditCustomEventModal();
    this.closeEventDetailsModal();
  }

  async destroyCustomEvent(customEvent) {
    await this.store.destroy(customEvent);
    await this.agent.refresh();
    this.closeEventDetailsModal();
  }
}

export default CalendarState;
